import { createSelector } from "reselect";
import { path, pathOr, prop } from "ramda";

const getNotesConfig = path(["domain", "ui", "notes"]);

export const selectNotesDLSOnly = createSelector(
  getNotesConfig,
  prop("dlsOnly")
);

const initialState = () => ({
  dlsOnly: pathOr(
    false,
    ["book", "ui", "notes", "dlsOnly"],
    window.getClientConfiguration()
  )
});

export default function reducer(state = initialState()) {
  return state;
}
